export default __webpack_public_path__ + "fe3ca47c704e81b8180f08c4960eb660.png";